import { topshotsAPI } from '../../app/api';

const forgottenApi = topshotsAPI.injectEndpoints({
  endpoints: (builder) => ({
    forgottenLogin: builder.mutation<void, { email: string }>({
      query: (request) => ({
        url: 'login/forgotten',
        method: 'POST',
        body: request,
      }),
    }),
    resetLogin: builder.mutation<
      { email: string },
      {
        password: string;
        duplicatePassword: string;
        token: string;
      }
    >({
      query: (request) => ({
        url: 'login/reset',
        method: 'POST',
        body: request,
      }),
    }),
  }),
});

export const { useForgottenLoginMutation, useResetLoginMutation } =
  forgottenApi;
